export default "__VITE_ASSET__d0e3f83e__"